var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 16 16",
    width: "16pt",
    height: "16pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_F010iMyuMpKQIqOnodEWM47ZJ5QrGyoF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_F010iMyuMpKQIqOnodEWM47ZJ5QrGyoF)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    style: {
      fill: "rgb(0,0,0)"
    },
    fillOpacity: 0
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 15 4 L 15 3 L 0 3 L 0 3 L 0 4 L 1 4 L 1 5 L 16 5 L 16 4 L 15 4 Z  M 15 8 L 15 7 L 0 7 L 0 7 L 0 8 L 1 8 L 1 9 L 16 9 L 16 8 L 15 8 L 15 8 L 15 8 Z  M 15 12 L 15 11 L 0 11 L 0 12 L 1 12 L 1 13 L 16 13 L 16 12 L 15 12 L 15 12 L 15 12 L 15 12 Z ",
    fillRule: "evenodd",
    fill: "rgb(255,255,255)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.b89872a6c32e389940ddb61e777897dd.svg";
export { ForwardRef as ReactComponent };